import { FogExp2, Group, Scene } from 'three';

const GROUP_KEYS = [
  'sceneRoot',
  'propRoot',
  'bulletRoot',
  'enemyShotRoot',
  'particleRoot',
  'pickupRoot',
  'ringRoot',
  'decalRoot',
  'wallRoot',
  'weatherRoot',
];

let scene = null;
let world = null;

export function initScene(options = {}) {
  const {
    fogColor = 0x060912,
    fogDensity = 0.021,
    size = 72,
  } = options;

  scene = new Scene();
  scene.fog = new FogExp2(fogColor, fogDensity);

  world = {
    size,
    half: size / 2,
    dynamicObjects: [],
  };

  for (const key of GROUP_KEYS) {
    const group = new Group();
    group.name = key;
    world[key] = group;
    scene.add(group);
  }

  return { scene, world };
}

export function getScene() {
  if (!scene) {
    throw new Error('[scene] initScene() must run before getScene().');
  }
  return scene;
}

export function getWorld() {
  if (!world) {
    throw new Error('[scene] initScene() must run before getWorld().');
  }
  return world;
}

export function setWorldSize(size) {
  const activeWorld = getWorld();
  activeWorld.size = size;
  activeWorld.half = size / 2;
}

export function setFog(color, density) {
  const activeScene = getScene();
  activeScene.fog = new FogExp2(color, density);
  return activeScene.fog;
}

export function addDynamicObject(object, root = getWorld().propRoot) {
  const activeWorld = getWorld();
  root.add(object);
  activeWorld.dynamicObjects.push(object);
  return object;
}

export function clearDynamicObjects() {
  const activeWorld = getWorld();
  for (const object of activeWorld.dynamicObjects) {
    if (object?.parent) {
      object.parent.remove(object);
    }
  }
  activeWorld.dynamicObjects.length = 0;
}
